import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { DESKTOP_STYLES, DESKTOP_COLORS } from '@/constants/admin';
import { SVG_COMPONENTS } from '@/assets/admin';
import { IColumnConfig, ISortModel } from '@/types/admin/dataTable';
import { styles } from './DesktopDataTableStyles';

type HeaderColumnConfig<T> = Pick<IColumnConfig<T>, 'key' | 'label' | 'sortable'>;

interface DesktopTableHeaderProps<T> {
  columns: HeaderColumnConfig<T>[];
  columnFlexGrow: number[];
  sortModel: ISortModel[];
  onSortChange?: (sortModel: ISortModel[]) => void;
  enableRowSelection?: boolean;
  selectedCount: number;
  totalCount: number;
  onSelectAll?: () => void;
  onDeselectAll?: () => void;
}

export const DesktopTableHeader = <T,>({
  columns,
  columnFlexGrow,
  sortModel,
  onSortChange,
  enableRowSelection,
  selectedCount,
  totalCount,
  onSelectAll,
  onDeselectAll,
}: DesktopTableHeaderProps<T>) => {
  return (
    <View style={[styles.tableHeader, DESKTOP_STYLES.tableHeader]}>
      <View style={styles.headerRow}>
        {enableRowSelection && (
          <View style={[styles.headerCell, { width: 50 }]}>
            <TouchableOpacity
              onPress={() => {
                if (selectedCount === totalCount) {
                  onDeselectAll?.();
                } else {
                  onSelectAll?.();
                }
              }}
              style={styles.checkbox}
            >
              {selectedCount === totalCount && totalCount > 0 && (
                <SVG_COMPONENTS.CHECK_CIRCLE width={16} height={16} color={DESKTOP_COLORS.BUTTON.PRIMARY_BACKGROUND} />
              )}
            </TouchableOpacity>
          </View>
        )}
        {columns.map((column, index) => (
          <TouchableOpacity
            key={column.key as string}
            style={[styles.headerCell, { flexGrow: columnFlexGrow[index], flexBasis: 0 }]}
            onPress={() => {
              if (column.sortable && onSortChange) {
                const currentSort = sortModel.find(sort => sort.field === column.key);
                const newDirection = currentSort?.sort === 'asc' ? 'desc' : 'asc';
                onSortChange([{ field: column.key as string, sort: newDirection }]);
              }
            }}
            disabled={!column.sortable}
          >
            <Text style={[styles.headerText, DESKTOP_STYLES.primaryText]}>
              {column.label}
            </Text>
            {column.sortable && (
              <View style={styles.sortIndicator}>
                {sortModel.find(sort => sort.field === column.key) ? (
                  <Text style={[styles.sortIndicatorText, { color: DESKTOP_COLORS.TABLE.SORT_INDICATOR }]}>
                    {sortModel.find(sort => sort.field === column.key)?.sort === 'asc' ? '↑' : '↓'}
                  </Text>
                ) : (
                  <Text style={[styles.sortIndicatorText, { color: DESKTOP_COLORS.TABLE.TEXT_SECONDARY }]}>↑</Text>
                )}
              </View>
            )}
          </TouchableOpacity>
        ))}
      </View>
    </View>
  );
};


